module.exports = __webpack_public_path__ + "media/images/features/4/album/main-1-743f44917fbe9d7ba0b84118ed713eb1.jpg";